import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { PaginatorProps, PaginationLink } from '../types';

const Paginator: React.FC<PaginatorProps> = ({ links: linksProps, visible = true }) => {
  const [isLargerThan1280, setIsLargerThan1280] = useState(window.innerWidth >= 1280);
  const [links, setLinks] = useState<PaginationLink[]>([]);

  const prevLink = links && links[0];
  const nextLink = links && links[links.length - 1];

  useEffect(() => {
    const handleResize = () => {
      setIsLargerThan1280(window.innerWidth >= 1280);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setLinks(linksProps);
  }, [linksProps]);

  return (
    <div className={`p-4 ${visible ? 'flex' : 'hidden'}`}>
      {!isLargerThan1280 && prevLink && nextLink && (
        <div className="flex gap-2">
          <Button
            disabled={!prevLink.url}
            variant={prevLink.active ? 'default' : 'outline'}
            className="mx-2"
            onClick={prevLink.onClick}
          >
            <div dangerouslySetInnerHTML={{ __html: prevLink.label }} />
          </Button>
          <Button
            disabled={!nextLink.url}
            variant={nextLink.active ? 'default' : 'outline'}
            className="mx-2"
            onClick={nextLink.onClick}
          >
            <div dangerouslySetInnerHTML={{ __html: nextLink.label }} />
          </Button>
        </div>
      )}
      {isLargerThan1280 && links?.map((link: PaginationLink, index: number) => {
        return (
          <Button
            key={`page-${link.label}-${index}`}
            disabled={!link.url}
            variant={link.active ? 'default' : 'outline'}
            className="mx-2"
            onClick={link.onClick}
          >
            <div dangerouslySetInnerHTML={{ __html: link.label }} />
          </Button>
        );
      })}
    </div>
  );
};

export default Paginator;
